import React, { useState } from "react";
import { Form } from "react-bootstrap";
import RadioControl from "../InputControls/RadioControl";
import { useStateValue } from "../../../store/StateProvider";
import { getSellerCreationErrors, getFieldValidationErrors } from "../../../utils/validator";
import { customChangeHandler } from "../../../utils/CustomChangeHandler";
import { actionTypes } from "../../../utils/constants";
import LabelWithLink from "../Elements/LabelWithLink";

const InputRadio = ({ fieldConfig, showErrors }) => {
  const [{ hiddenFields, formValues, sellerCreationErrors }, dispatch] = useStateValue();
  const sellerCreationFieldError = getSellerCreationErrors(fieldConfig.id, sellerCreationErrors);
  const [errorMessage, setErrorMessage] = useState(sellerCreationFieldError);
  const [firstLoad, setFirstLoad] = useState(true);

  const labelClass = `input_label_plain ${fieldConfig.labelClass}`;

  const setError = error => {
    setErrorMessage(error);
  };

  const executeFieldValidation = value => {
    const error = getFieldValidationErrors(fieldConfig.validators, { [fieldConfig.id]: value }, fieldConfig.id);
    setError(error);
  };

  const handleChange = e => {
    const valueFieldChange = customChangeHandler(e, fieldConfig, formValues);

    if (valueFieldChange) {
      const fieldChange = fieldConfig.onChange.params.field;

      dispatch({
        type: actionTypes.PRESERVE_GLOBAL_STATE,
        payload: { [fieldChange]: valueFieldChange }
      });
    }
  };

  return (
    <Form.Group
      className={`mb3 ${fieldConfig.containerClass} ${hiddenFields.includes(fieldConfig.id) ? "hidden" : ""}`}
      id={`container_${fieldConfig.id}`}
      controlId={fieldConfig.id}>
      <LabelWithLink
        labelText={fieldConfig.label}
        linkText={fieldConfig.labelLinkText}
        link={fieldConfig.labelLink}
        className={labelClass}
        labelMandatory={fieldConfig.labelMandatory}
        infoText={fieldConfig.info}
      />
      <LabelWithLink
        labelText={fieldConfig.labelDescription}
        linkText={fieldConfig.labelDescLinkText}
        link={fieldConfig.labelDescLink}
        className="label_description"
      />
      <RadioControl
        fieldConfig={fieldConfig}
        fieldValidator={executeFieldValidation}
        removeErrorMessage={setError.bind(this, null)}
        onChange={handleChange}
        showErrors={showErrors}
        setFirstLoad={setFirstLoad}
      />
      <input
        type="hidden"
        id={fieldConfig.id}
        name={fieldConfig.id}
        value={formValues[fieldConfig.id] ? formValues[fieldConfig.id] : ""}
        readOnly
      />
      <Form.Label
        className={`label_error ${!!errorMessage && (!firstLoad || showErrors || sellerCreationFieldError) ? "show" : "hidden"}`}
        id={`label_error_${fieldConfig.id}`}>
        <span id={`label_error_message_${fieldConfig.id}`}>{errorMessage}</span>
      </Form.Label>
    </Form.Group>
  );
};

export default InputRadio;
